import { Button, DatePicker, Form, Input, InputNumber, Radio, Select } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';

import { getAgentPendingReceiptList, PendingReceiptPayload } from 'api/receipt';
import PendingReceiptList from '../PendingReceiptList';
import xlsx from 'json-as-xlsx';
import { FileExcelFilled } from '@ant-design/icons';
import { getSelectList, SelectList, SelectPayload, SelectResponse } from 'api/dashboard';
import moment from 'moment';
import { handleOnlyNumber } from 'features/nach/utils/handleOnlyNumber';

export interface Props {
  isLoading: boolean;
  onSubmit: (values: PendingReceiptPayload) => Promise<void>;
}

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}
// const SourceApplicationName = sessionStorage.getItem('source')?.toString();
const initPartners: SelectList[] = [];
const dateFormat = 'DD/MM/YYYY';
const initSelectResp: SelectResponse = {
  data: [],
};
let filterPayload: PendingReceiptPayload = {
  Username: sessionStorage.getItem('user')?.toString(),
  // SourceApplicationName: SourceApplicationName,
};

const ReceiptPending = ({ onSubmit }: Props) => {
  const { Option } = Select;
  const [form] = Form.useForm<PendingReceiptPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [statusList, setStatus] = useState(initPartners);
  const isAdmin = sessionStorage.getItem('isAdmin');
  const [statusId, setStatusId] = useState(0);
  const [_sourceId, setSourceId] = useState(0);
  const [sources, setSource] = useState(initSelectResp);
  const [, isSearch] = useState(false);
  const [feeType, setFeeType] = useState('UpFront');
  const [onlyDigitError, setOnlyDigitError] = useState(false);
  // const [pendingReceipts, setPendingReceipts] = useState<AgentPendingReceiptListData[]>([]);

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'StatusSource',
    };
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });

    // setAdmin(adminRole);
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'Source',
      };
      // setIsLoading(false);
      getSelectList(sourcePayload).then((res) => {
        // setPagedList(res);
        //   setIsLoading(true);
        setSource(res);
      });
    }
  }, []);

  // console.log('pendingReceipts from Recipt pending ', pendingReceipts);

  // useEffect(() => {
  //   const fetchPendingReceipts = async () => {
  //     try {
  //       filter.IsExtract = false; // Ensure this flag is false on initial fetch
  //       const response: PendingReceiptPagedList = await getAgentPendingReceiptList(filter);

  //       if (response.data && response.data.data) {
  //         setPendingReceipts(response.data.data); // This should now work without error
  //       }
  //     } catch (error) {
  //       console.error('Error fetching pending receipts:', error);
  //     }
  //   };

  //   fetchPendingReceipts(); // Call the function to fetch data
  // }, []);

  const handleStatusId = (e: any) => {
    form.setFieldValue('statusId', e);
    form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  const handleSubmit = useCallback(
    async (values: PendingReceiptPayload) => {
      let updatedValues = { ...values };
      updatedValues.Username = sessionStorage.getItem('user')?.toString();
      if (isAdmin != 'true') {
        updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      }
      console.log('filter valur', values);
      // updatedValues.SourceApplicationName = sessionStorage.getItem('source')?.toString();
      setFilter(updatedValues);
      // form.resetFields();
    },
    [onSubmit, form]
    // async (values: PendingReceiptPayload) => {
    //   await onSubmit(values);
    //   setFilter(values);
    //   // form.resetFields();
    // },
    // [onSubmit, form]
  );

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'StatusSource',
    };
    getSelectList(statusPayload).then((res) => {
      // setPagedList(res);
      //   setIsLoading(true);
      setStatus(res.data);
    });

    // setAdmin(adminRole);
    if (isAdmin == 'true') {
      const sourcePayload: SelectPayload = {
        SKey: 'Source',
      };
      // setIsLoading(false);
      getSelectList(sourcePayload).then((res) => {
        // setPagedList(res);
        //   setIsLoading(true);
        setSource(res);
      });
    }
  }, []);

  // const handleStatusId = (e: any) => {
  //   form.setFieldValue('statusId', e);
  //   form.validateFields(['statusId']);
  //   setStatusId(Number(e));
  // };

  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    isSearch(false);
  }

  function handleDownload(_e: any) {
    filter.IsExtract = true;
    delete filter.pageNo;
    delete filter.pageSize;
    getAgentPendingReceiptList(filter).then((_x) => {
      let settings = {
        fileName: 'PendingReceiptRequest -Report', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,
        PaymentRequestDateTime: getFullDate(item.PaymentRequestDateTime),
        valueDate: getFullDate(item.valueDate),
        PennantReceiptDate: getFullDate(item.PennantReceiptDate),
        ROWNUM: index + 1,
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'FeeType', value: 'FeeType' },
            { label: 'FeeCode', value: 'FeeCode' },
            { label: 'FeeAmount', value: 'FeeAmount' },
            { label: 'FeeDescription', value: 'FeeDescription' },
            { label: 'Amount', value: 'Amount' },
            { label: 'LAN Number', value: 'LANumber' },
            { label: 'Request Purpose', value: 'RequestPurpose' },
            { label: 'Source Application Name', value: 'SourceApplicationName' },
            { label: 'Payment Request ID', value: 'PaymentRequestID' },
            { label: 'Loan Type', value: 'LoanType' },
            { label: 'RequestStatus', value: 'RequestStatus' },
            { label: 'new Status', value: 'new_status' },
            { label: 'Currency', value: 'Currency' },
            { label: 'SessionID', value: 'SessionID' },
            { label: 'Payment Purpose', value: 'PAYMENTPURPOSE' },
            { label: 'Merchant ID', value: 'merchantId' },
            { label: 'PaymentRequestDateTime', value: 'PaymentRequestDateTime' },
            { label: 'Mode', value: 'Mode' },
            { label: 'Ref Transaction', value: 'RefTransaction' },
            { label: 'PaymentRef', value: 'paymentRef' },
            { label: 'BankCode', value: 'bankCode' },
            { label: 'valueDate', value: 'valueDate' },
            { label: 'FavourName', value: 'favourName' },
            { label: 'Remark', value: 'remarks' },
            { label: 'razorpay_order_id', value: 'razorpay_order_id' },
            { label: 'razorpay_payment_id', value: 'razorpay_payment_id' },
            { label: 'FundingAccount', value: 'FundingAccount' },
            { label: 'PennantReceiptNo', value: 'PennantReceiptNo' },
            { label: 'PennantReceiptDate', value: 'PennantReceiptDate' },
            { label: 'PennantErrorDesc', value: 'PennantErrorDesc' },
            { label: 'auth_code', value: 'auth_code' },
            { label: 'PaymentRequestError', value: 'PaymentRequestError' },
            { label: 'WebhookError ', value: 'WebhookError' },
            { label: 'verification reason', value: 'verificationReason' },
            { label: 'AccountId', value: 'AccountId' },
            { label: 'ByAgent', value: 'ByAgent' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }
  const memoizedFilter = useMemo(() => filter, [filter]);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Pending For Receipt</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form<PendingReceiptPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Loan Number :'} name="LANumber" className="fieldTitle">
                          <Input placeholder={'Loan Number'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Order ID :'} name="OrderId" className="fieldTitle">
                          <Input placeholder={'Order ID'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Status :'} name="RequestStatus" className="fieldTitle">
                          {/* <InputNumber placeholder={'Status'} /> */}
                          {/* <Select defaultValue="0" size="large" style={{ fontWeight: 'lighter' }}>
                            <Option value="0">Select</Option>
                            <Option value="CONFIRMATION_REQUIRED">CONFIRMATION_REQUIRED</Option>
                            <Option value="DUPLICATE_REQUEST">DUPLICATE_REQUEST</Option>
                            <Option value="EMAIL_COMPLETED">EMAIL_COMPLETED</Option>
                            <Option value="EMAIL_FAILED">EMAIL_FAILED</Option>
                            <Option value="EMAIL_PROCESSING">EMAIL_PROCESSING</Option>
                            <Option value="LINK_EXPIRED">LINK_EXPIRED</Option>
                            <Option value="NEW_REQUEST">NEW_REQUEST</Option>
                            <Option value="ORDER_GENERATED">ORDER_GENERATED</Option>
                            <Option value="PAYMENT_COMPLETED">PAYMENT_COMPLETED</Option>
                            <Option value="PAYMENT_FAILED">PAYMENT_FAILED</Option>
                            <Option value="RECEIPT_COMPLETED">RECEIPT_COMPLETED</Option>
                            <Option value="RECEIPT_FAILED">RECEIPT_FAILED</Option>
                            <Option value="RECEIPT_PROCESSING">RECEIPT_PROCESSING</Option>
                            <Option value="SMS_COMPLETED">SMS_COMPLETED</Option>
                            <Option value="SMS_FAILED">SMS_FAILED</Option>
                            <Option value="SMS_PROCESSING">SMS_PROCESSING</Option>
                          </Select> */}
                          <Select
                            defaultValue={'Select'}
                            size="large"
                            value={statusId.toString()}
                            onSelect={handleStatusId}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SValue}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Purpose:'}
                          name="PaymentPurpose"
                          className="fieldTitle"
                        >
                          {/* <InputNumber placeholder={'Payment Purpose'} /> */}
                          <Select placeholder="Select" size="large">
                            <Option value="Fees">Fees</Option>
                            <Option value="Foreclosure">Foreclosure</Option>
                            <Option value="Overdue">Overdue</Option>
                            <Option value="OverdueWithoutCharges">Overdue Without Charges</Option>
                            <Option value="PartPayment">PartPayment</Option>
                            <Option value="ADVANCEEMI">Advance EMI</Option>
                            <Option value="OtherCharges">Other Charges</Option>
                            <Option value="Post Disbursement">Post disbursement</Option>
                            <Option value="VAS">VAS</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Request Purpose:'}
                          name="RequestPurpose"
                          className="fieldTitle"
                        >
                          {/* <InputNumber placeholder={'Request Purpose'} /> */}
                          <Select placeholder="Select" size="large">
                            <Option value="Payment">Payment</Option>
                            <Option value="Receipt">Receipt</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Payment ID :'} name="PaymentId" className="fieldTitle">
                          <Input placeholder={'Payment ID'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Date From :'}
                          name="FromDate"
                          className="fieldTitle"
                        >
                          {/* <Input placeholder={'Payment Date From'} /> */}
                          <DatePicker format={dateFormat} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'To :'} name="ToDate" className="fieldTitle">
                          {/* <Input placeholder={'To'} /> */}
                          <DatePicker format={dateFormat} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        {isAdmin == 'true' ? (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="SourceApplicationName"
                            className="fieldTitle"
                          >
                            <Select
                              defaultValue={'Select'}
                              size="large"
                              value={statusId.toString()}
                              onSelect={handleSourceId}
                            >
                              {/* <Option value="0">Select</Option> */}
                              {sources.data.map((role) => (
                                <Option value={role.SValue}>{role.SText}</Option>
                              ))}
                            </Select>
                          </Form.Item>
                        ) : (
                          <Form.Item
                            label={'Source Application Name :'}
                            name="SourceApplicationName"
                            className="fieldTitle"
                          >
                            <Input
                              disabled={true}
                              style={{
                                border: '1px solid #dcdcdc',
                                borderRadius: '4px',
                                fontWeight: '600',
                                background: '#fafbfa',
                                opacity: 0.5,
                              }}
                            />
                          </Form.Item>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item label={'Merchant ID :'} name="MerchantId" className="fieldTitle">
                          <Input placeholder={'MerchantId'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Reference No :'}
                          name="PaymentRefNo"
                          className="fieldTitle"
                        >
                          <Input placeholder={'Payment Reference No'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Payment Request ID :'}
                          name="PaymentRequestId"
                          className="fieldTitle"
                          validateStatus={onlyDigitError ? 'error' : ''}
                          help={onlyDigitError ? 'Only numbers are allowed' : ''}
                        >
                          <InputNumber
                            value={form.getFieldValue('PaymentRequestId')}
                            onBeforeInput={(e) => handleOnlyNumber(e, setOnlyDigitError)}
                            placeholder={'Payment Request ID:'}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <div className="input-box">
                        <Form.Item
                          label={'Fee Type :'}
                          name="FeeType"
                          style={{ cursor: 'pointer' }}
                          className="fieldTitle"
                        >
                          <Radio.Group
                            name="FeeType"
                            value={feeType}
                            className=""
                            onChange={(e) => setFeeType(e.target.value)}
                            data-toggle="buttons"
                            style={{ paddingBottom: '10px', width: '100%' }}
                          >
                            <label
                              role="button"
                              className="btn btn-primary"
                              style={{
                                marginRight: '10px',
                                fontWeight: '400',
                                fontSize: '14px',
                                fontFamily: 'sans-serif,regular',
                                backgroundColor: feeType == 'Upfront' ? '#0062cc' : '#007bff',
                              }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="FeeType"
                                name="FeeType"
                                type="radio"
                                value="Upfront"
                              />
                              Upfront
                            </label>
                            <label
                              role="button"
                              className="btn btn-primary"
                              style={{
                                marginRight: '10px',
                                fontWeight: '400',
                                fontSize: '14px',
                                fontFamily: 'sans-serif,regular',
                                backgroundColor:
                                  feeType == 'Post Disbursement' ? '#0062cc' : '#007bff',
                              }}
                            >
                              <Radio
                                className="rblFeeType"
                                id="FeeType"
                                name="FeeType"
                                type="radio"
                                value="Post Disbursement"
                              />
                              Post Disbursement
                            </label>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4"></div>
                    <div className="col-xs-12 col-sm-4 col-md-4">
                      <Button
                        type="link"
                        icon={<FileExcelFilled />}
                        style={{
                          float: 'right',
                          fontSize: '30px',
                          color: 'green',
                          marginTop: '50px',
                          marginLeft: '10px',
                        }}
                        onClick={handleDownload}
                      ></Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginTop: '50px', marginLeft: '10px' }}
                        onClick={handleReset}
                      >
                        {'CLEAR'}
                      </Button>

                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginTop: '50px' }}
                        onClick={() => {
                          isSearch(true);
                        }}
                      >
                        {'SEARCH'}
                      </Button>
                    </div>
                  </div>
                </Form>
                <PendingReceiptList filter={memoizedFilter} setOnlyDigitError={setOnlyDigitError} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPending;
